/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CustomWidgetPoint.vue?vue&type=template&id=790c4cd4&"
import script from "./CustomWidgetPoint.vue?vue&type=script&lang=js&"
export * from "./CustomWidgetPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports